export const MAX_TITLE_LENGTH = 50;
export const MAX_CAPTION_LENGTH = 50;
export const MAX_DESCRIPTION_LENGTH = 645000; // 640kb
export const MAX_TAGS = 30;
export const MAX_ATTACHMENTS = 9;
export const MAX_ATTACHMENTS_CORE = 99;

export const SAVED_SUBMISSIONS_FOLDER_NAME = 'Saved Submissions';
